import { render, staticRenderFns } from "./EmailBroadcastItem.vue?vue&type=template&id=137e3533&scoped=true"
import script from "./EmailBroadcastItem.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastItem.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastItem.vue?vue&type=style&index=0&id=137e3533&prod&lang=css"
import style1 from "./EmailBroadcastItem.vue?vue&type=style&index=1&id=137e3533&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e3533",
  null
  
)

export default component.exports